const isTouchDevice = () => {
	return (('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0));
}

const transformSpike = (card, spike) => {
	const square = spike.querySelector('.mr_bosmans_square');
	const cardWidth = card.offsetWidth;
	const ratio = card.offsetHeight / card.offsetWidth;

	const GROW_ANIMATION = 'MR_GROW_PRODUCT_CARD_SPIKE';
	const SHRINK_ANIMATION = 'MR_SHRINK_PRODUCT_CARD_SPIKE';

	spike.style.width = `${cardWidth}px`;
	spike.style.height = `${cardWidth}px`;
	spike.style.transform = `translate(-50%, -50%) scale(1.9, ${ratio + 1})`;

	document.documentElement.style.setProperty('--mr-spike-animation-height', `-${cardWidth * 5}px`);

	const applyAnimation = (name) => {
		square.style.animationName = name;
	};

	const handleAnimationEnd = (event) => {
		if (event.animationName === SHRINK_ANIMATION) {
			card.classList.remove('is-active');
		}
	};

	if (isTouchDevice()) {
		const observerOptions = {
			root: null,
			rootMargin: '-50% 0px',
			threshold: 0
		};

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					applyAnimation(GROW_ANIMATION)
					card.classList.add('is-active');
				} else {
					applyAnimation(SHRINK_ANIMATION)
					square.addEventListener('animationend', handleAnimationEnd)
				}
			});
		}, observerOptions);

		observer.observe(card);
	}

	if (!isTouchDevice()) {
		card.addEventListener('mouseenter', () => {
			applyAnimation(GROW_ANIMATION)
		})

		card.addEventListener('mouseleave', () => {
			applyAnimation(SHRINK_ANIMATION)
		})
	}

}

const hideFlickityPageDot = () => {
	const dots = Array.from(document.querySelectorAll('.flickity-page-dots .dot'));
	if (dots.length === 1) {
		dots[0].style.display = 'none';
	}
}

const highlightSpikes = () => {
	const selectors = [
		'.slideshow .slideshow__slide-heading .line-child',
		'.template-page-about .post-content.rte'
	]
	let allSpans = [];

	const animateFontVariation = (spans, totalIntervals = 1) => {
		let indices = [0, spans.length];
		let currentIndex = 0;
		let intervalCount = 0;
		let animationInterval;

		const applyAnimation = () => {
			const startIndex = indices[currentIndex];
			let endIndex = indices[(currentIndex + 1) % indices.length]; //target the next index

			const step = startIndex < endIndex ? 1 : -1; // check in which direction, left, right.

			const animateThroughIndices = (index) => {
				if (index === endIndex) return;

				applyFontVariation(index, spans, 350);

				setTimeout(() => {
					animateThroughIndices(index + step);
				}, 100);
			};

			animateThroughIndices(startIndex);

			//update index in the array
			currentIndex = (currentIndex + 1) % indices.length;
		};

		animationInterval = setInterval(() => {
			applyAnimation();

			intervalCount++;

			if (intervalCount >= totalIntervals) {
				clearInterval(animationInterval);

				//reset font variations when last animation is done.
				setTimeout(() => {
					resetFontVariation(spans);
				}, spans.length * 100);
			}
		}, spans.length * 100);
	};

	const applyFontVariation = (hoverIndex, spans, steps = 50) => {
		// Increasing (to the right of the hovered character)
		for (let i = hoverIndex, opsz = 900, scale = 1.1; i < spans.length && scale >= 1; i++, opsz -= steps, scale -= 0.05) {
			spans[i].style.fontVariationSettings = `'opsz' ${opsz}`;
			spans[i].style.transform = `translateY(var(--mr-font-offset)) scale(${scale}, ${scale})`;
		}

		// Decreasing (to the left of hovered character)
		for (let i = hoverIndex - 1, opsz = 800, scale = 1.1; i >= 0 && scale >= 1; i--, opsz -= steps, scale -= 0.05) {
			spans[i].style.fontVariationSettings = `'opsz' ${opsz}`;
			spans[i].style.transform = `translateY(var(--mr-font-offset)) scale(${scale}, ${scale})`;
		}
	};

	const resetFontVariation = (spans) => {
		spans.forEach((span) => {
			span.style.fontVariationSettings = '';
			span.style.transform = 'translateY(var(--mr-font-offset)) scale(1, 1)';
		});
	};

	selectors.forEach((selector) => {
		const textNodes = Array.from(document.querySelectorAll(selector));

		if (!textNodes) {
			return;
		}

		textNodes.forEach((textNode, NodeIndex) => {
			const textContent = textNode.textContent;
			// console.log(textNodes, textNode, textContent.length, NodeIndex)

			if (!textContent) {
				return;
			}

			textNode.textContent = "";

			let cumulativeIndex = 0;
			let position;

			for (const [wordIndex, word] of textContent.split(' ').entries()) {
				const wordSpan = document.createElement('span');

				if (word) {
					wordSpan.classList.add('word');
					for (const [charIndex, char] of word.split('').entries()) {
						const span = document.createElement('span');
						span.textContent = char;

						if (NodeIndex > 0) {
							let wordCount = textNodes[NodeIndex - 1].textContent.length
							position = wordCount + cumulativeIndex ;
						} else {
							position = cumulativeIndex
						}

						let character = {
							'span': span,
							'position': position
						};

						if (char === " ") {
							span.classList.add('spike-word-empty');
						} else {
							allSpans.push(character);
							span.classList.add('spike-word');
						}

						wordSpan.appendChild(span);

						span.addEventListener('mouseenter', () => {
							applyFontVariation(character.position, allSpans.map(s => s.span));
						});

						span.addEventListener('mouseleave', () => {
							resetFontVariation(allSpans.map(s => s.span));
						});

						cumulativeIndex++;
					}

					textNode.appendChild(wordSpan);

				}
			}
		});
	})

	//if the amount of characters <= 30
	if (allSpans.length <= 30) {
		animateFontVariation(allSpans.map(s => s.span))
	}

	//if it's a touch device and the amount of characters > 30
	if (isTouchDevice() && allSpans.length > 30 ) {
		const observerOptions = {
			root: null,
			rootMargin: '-50% 0px',
			threshold: 0
		};

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('spike')
				} else {
					entry.target.classList.remove('spike')
				}
			});
		}, observerOptions);
		
		allSpans.forEach(span => {
			console.log(span)
			observer.observe(span.span);
		})
	}

	openMobileMenuOnClick();

};

const openMobileMenuOnClick = () => {
	const frontPageBody = document.querySelector('.template-index');

	if (!frontPageBody) {
		return;
	}

	const mobileWrapper = frontPageBody.querySelector('.mobile-toggle-wrapper');
	const words = frontPageBody.querySelectorAll('.slideshow .slideshow__slide-content .word');
	
	if (!mobileWrapper || !words) {
		return;
	}

	const isOpen = mobileWrapper.getAttribute('open');

	if (isOpen) {
		return
	}

	words.forEach(word => {
		word.addEventListener('click', () => {
			mobileWrapper.setAttribute('open', 'true');
			mobileWrapper.classList.add('active');
			frontPageBody.classList.add('overflow-hidden');
			window.scrollTo({
				top: 0,  
				left: 0, 
				behavior: "instant"
			  });
		})
	})
}

const productSquareSpike = () => {
	const productCards = Array.from(document.querySelectorAll('.products .product-card'));
	productCards.shift(); //remove first item, prevent animation to go over product filter

	if (!productCards) {
		return;
	}

	/*
		We want very little occurrences of this feature. 1 or 2 per 10. 
		If less then 10 product items, the amount is set to 1.
	*/
	const shuffled = productCards.sort(() => 0.5 - Math.random());
	const selected = productCards.length < 10
		? shuffled.slice(0, 1)
		: shuffled.slice(0, Math.floor(productCards.length / 10));

	const resizeSpikes = () => {
		selected.forEach((card) => {
			card.classList.add('spikes');
			const spike = card.querySelector('.mr_bosmans_square-spike');
			if (spike) transformSpike(card, spike);
		});
	};

	resizeSpikes();
	window.addEventListener('resize', resizeSpikes);
}

const mrBosmansGlobal = () => {
	highlightSpikes();
	productSquareSpike();
	hideFlickityPageDot();
}

class MrBosmansSquareSpike extends HTMLElement {
	handleMouseLeave = () => {
		this.isOpen = this.toggleWrapper.classList.contains('active');
		requestAnimationFrame(() => {
			this.spike.style.animationName = this.isOpen
				? "MR_GROW_SQUARE_SPIKE"
				: "MR_SHRINK_SQUARE_SPIKE";
		});
	}

	handleMouseEnter = () => {
		this.isOpen = this.toggleWrapper.classList.contains('active');
		requestAnimationFrame(() => {
			this.spike.style.animationName = this.isOpen
				? "MR_SHRINK_SQUARE_SPIKE"
				: "MR_GROW_SQUARE_SPIKE";
		});
	}

	connectedCallback() {
		requestAnimationFrame(() => {
			this.spike = this.querySelector('.mr_bosmans_square');

			if (!this.spike) {
				return;
			}

			this.toggleWrapper = this.spike.closest('.mobile-toggle-wrapper');

			if (!this.toggleWrapper) {
				return;
			}

			this.addEventListener('mouseleave', this.handleMouseLeave);
			this.addEventListener('mouseenter', this.handleMouseEnter);
		});
	}
	disconnectedCallback() {
		this.removeEventListener('mouseleave', this.handleMouseLeave);
		this.removeEventListener('mouseenter', this.handleMouseEnter);
	}
}

class MrPopoverOnMouseMove extends HTMLElement {
	handleMouseMove = (e) => {
		const img = this.querySelector('img');
		if (!img) {
			return;
		}

		const mousePositionX = e.clientX;
		const mousePositionY = e.clientY;

		const imgDimension = img.getBoundingClientRect();
		const overflow = this.checkWindowOverflow(mousePositionX, mousePositionY, imgDimension);
		const offset = 20;

		let left = mousePositionX + offset;
		let top = mousePositionY + offset;

		if (overflow === 'right' || overflow === 'bottom-right') {
			left = mousePositionX - (imgDimension.width + offset);
		} else if (overflow === 'bottom' || overflow === 'bottom-right') {
			top = mousePositionY - (imgDimension.height + offset);
		}

		img.style.left = `${left}px`;
		img.style.top = `${top}px`;
	}

	connectedCallback() {
		this.addEventListener('mousemove', this.handleMouseMove);
	}

	disconnectedCallback() {
		this.removeEventListener('mousemove', this.handleMouseMove);
	}

	checkWindowOverflow(mousePositionX, mousePositionY, element) {
		const rightOverflow = (mousePositionX + element.width) > window.innerWidth;
		const bottomOverflow = (mousePositionY + element.height) > window.innerHeight;

		if (rightOverflow && bottomOverflow) {
			return 'bottom-right';
		}
		if (rightOverflow) {
			return 'right';
		}
		if (bottomOverflow) {
			return 'bottom';
		}

		return;
	}
}

class MrMasonry extends HTMLElement {
	observeDOMChanges() {
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				const addedItems = Array.from(mutation.addedNodes)
					.filter(node => node.nodeType === 1 && node.hasAttribute('mr-masonry-item'))
					.map(node => node.querySelector(':first-child'))
					.filter(firstChild => firstChild !== null);

				if (addedItems.length > 0) {
					this.calculateItemHeight();
				}
			}
		});

		observer.observe(this, { childList: true, subtree: true });
	}

	calculateItemHeight = () => {
		if (window.innerWidth <= 568) {
			return;
		}

		const items = Array.from(this.querySelectorAll('[mr-masonry-item]'))
			.map(item => item.querySelector(':first-child'))
			.filter(firstChild => firstChild !== null);

		if (items.length === 0) {
			return;
		}

		items.forEach(item => {
			const height = item.getBoundingClientRect().height;
			const rowEnd = Math.round(height);
			const gridItem = item.closest('[mr-masonry-item]');
			gridItem.style.gridRowEnd = 'span ' + rowEnd;
		})
	}

	debounce = (func, delay) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), delay);
		};
	}

	connectedCallback() {
		this.observeDOMChanges();
		this.calculateItemHeight();
		this.debouncedResize = this.debounce(this.calculateItemHeight, 200);
		window.addEventListener('resize', this.calculateItemHeight)
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this.debouncedResize);
	}
}

class MrRandomShelly extends HTMLElement {
	getRandomPositionInViewport = (shelly, headerHeight) => {
		const shellyDimensions = shelly.getBoundingClientRect();
		const bodyDimensions = document.querySelector('body').getBoundingClientRect();
		const viewportHeight = window.innerHeight;

		const maxX = bodyDimensions.width - shellyDimensions.width;
		const maxY = Math.min(bodyDimensions.height, viewportHeight) - headerHeight - shellyDimensions.height;

		const randomX = Math.random() * maxX;
		const randomY = Math.random() * maxY;

		return {
			top: randomY + (window.scrollY + headerHeight),
			left: randomX
		};
	}

	typeWriter = (element, text) => {
		let typingSpeed = 0.05;
		let index = 0;

		const type = () => {
			if (index < text.length) {
				element.textContent += text.charAt(index);
				index++;
				requestAnimationFrame(() => {
					setTimeout(type, typingSpeed * 1000);
				});
			}
		}
		type();
	}

	setShellyPosition = (shelly, headerHeight) => {
		const position = this.getRandomPositionInViewport(shelly, headerHeight);
		shelly.style.opacity = '1';
		shelly.style.top = `${position.top}px`;
		shelly.style.left = `${position.left}px`;
	}

	moveShelly = (shelly, headerHeight) => {
		const shellyInnerText = this.querySelector('.random-shelly__shelly__text span');
		const sentences = [
			'The world is your oyster',
			'All bears are cute',
			'Cow, cow, cows',
			'Keep moving forward!',
			'Caroline Bosmans'
		];

		const randomSentence = sentences[Math.floor(Math.random() * sentences.length)];

		this.setShellyPosition(shelly, headerHeight);

		this.typeWriter(shellyInnerText, randomSentence, 0);

		shelly.addEventListener('mouseenter', () => {
			this.setShellyPosition(shelly, headerHeight);
		});

	}

	connectedCallback() {
		requestAnimationFrame(() => {
			const headerHeight = document.querySelector('theme-header').getBoundingClientRect().height;
			const shouldRun = Math.random() < 0.5;
			const shelly = this.querySelector('.random-shelly__shelly');

			if (!shelly) {
				return;
			}

			if (shouldRun) {
				const randomDelay = Math.floor(Math.random() * (5000 - 3000 + 1)) + 3000;
				const runOnMount = Math.random() < 0.5;

				const onScroll = () => {
					if (window.scrollY >= 600) {
						this.moveShelly(shelly, headerHeight);
						window.removeEventListener('scroll', onScroll);
					}
				};

				if (runOnMount) {
					setTimeout(this.moveShelly(shelly, headerHeight), randomDelay);
				} else {
					window.addEventListener('scroll', onScroll);
				}
			}
		});
	}
}

customElements.define('mr-popover-on-mouse-move', MrPopoverOnMouseMove);
customElements.define('mr-bosmans-square-spike', MrBosmansSquareSpike);
customElements.define('mr-random-shelly', MrRandomShelly);
customElements.define('mr-masonry', MrMasonry);
document.addEventListener('DOMContentLoaded', mrBosmansGlobal);

